__turbopack_context__.v({
  "active": "best-sellers-module__0TuSdW__active",
  "bestSellerBadge": "best-sellers-module__0TuSdW__bestSellerBadge",
  "bestSellers": "best-sellers-module__0TuSdW__bestSellers",
  "bestSellersFrame": "best-sellers-module__0TuSdW__bestSellersFrame",
  "bestSellersHeading": "best-sellers-module__0TuSdW__bestSellersHeading",
  "bestSellersWrapper": "best-sellers-module__0TuSdW__bestSellersWrapper",
  "car": "best-sellers-module__0TuSdW__car",
  "carDetails": "best-sellers-module__0TuSdW__carDetails",
  "category": "best-sellers-module__0TuSdW__category",
  "discountMessage": "best-sellers-module__0TuSdW__discountMessage",
  "discountMessageDiscount": "best-sellers-module__0TuSdW__discountMessageDiscount",
  "indicatorSegment": "best-sellers-module__0TuSdW__indicatorSegment",
  "indicatorWrapper": "best-sellers-module__0TuSdW__indicatorWrapper",
  "model": "best-sellers-module__0TuSdW__model",
  "modelLink": "best-sellers-module__0TuSdW__modelLink",
  "navButton": "best-sellers-module__0TuSdW__navButton",
  "navLeft": "best-sellers-module__0TuSdW__navLeft",
  "navRight": "best-sellers-module__0TuSdW__navRight",
  "price": "best-sellers-module__0TuSdW__price",
  "prices": "best-sellers-module__0TuSdW__prices",
  "scrollUpButton": "best-sellers-module__0TuSdW__scrollUpButton",
  "scrollUpRow": "best-sellers-module__0TuSdW__scrollUpRow",
  "transmission": "best-sellers-module__0TuSdW__transmission",
  "year": "best-sellers-module__0TuSdW__year",
});
